import { SubStepLink, SubStepListItem } from "./styled";
import React from "react";
import { VerticalLine } from "../../../styled";
export const SubStepItem = ({ subStep, active, handleNavigate, branding, }) => {
    const onKeyDown = (event) => {
        if (event.key === "Enter") {
            handleNavigate(subStep);
        }
    };
    const tabIndex = subStep.complete ? 0 : -1;
    return (React.createElement(SubStepListItem, { title: subStep.title },
        React.createElement(VerticalLine, { "$active": active, branding: branding }),
        React.createElement(SubStepLink, { tabIndex: tabIndex, "$active": active, "aria-label": subStep.ariaLabel, "$completed": subStep.complete, onClick: () => handleNavigate(subStep), onKeyDown: onKeyDown }, subStep.title)));
};
//# sourceMappingURL=index.js.map